import { useLocation, Navigate, Outlet } from "react-router-dom";
//import { useCookies } from "react-cookie";
import routeConstants from "../constants/routesContent.json";
import { getCookie } from "../utils/service";

const RouteProtection = () => {
  const location = useLocation();
  //const [cookies] = useCookies(["user"]);
  const xAccessToken = getCookie('xAccessToken')
  let loadComponent = false;
  let route = routeConstants.LOGIN;


    if (xAccessToken) {

        loadComponent = true;

    } else {
      route = routeConstants.LOGIN;
    }

  return (
    <>
      {loadComponent ? (
        <Outlet />
      ) : (
        <Navigate to={route} state={{ from: location }} replace />
      )}
    </>
  );
};

export default RouteProtection;
